import { FC } from "react"
import { IconProps } from "@/components/shared/Icon"

const EditIcon: FC<IconProps> = ({ ...props }) => {
   return (
      <svg
         viewBox="0 0 24 24"
         fill="none"
         {...props}
      >
         <path
            d="M20.8316 2.59686L21.4031 3.16843C21.8472 3.61246 21.8472 4.33046 21.4031 4.76977L20.0285 6.14909L17.8509 3.97146L19.2255 2.59686C19.6695 2.15283 20.3875 2.15283 20.8268 2.59686H20.8316ZM9.91035 11.9167L16.2496 5.5728L18.4272 7.75043L12.0833 14.0897C11.9463 14.2266 11.7762 14.3258 11.592 14.3778L8.82862 15.1667L9.61748 12.4033C9.66944 12.2191 9.76864 12.049 9.90562 11.912L9.91035 11.9167ZM17.6242 0.995522L8.30429 10.3107C7.89332 10.7216 7.59573 11.2271 7.43985 11.7798L6.08886 16.5035C5.9755 16.9003 6.08414 17.3254 6.37701 17.6183C6.66988 17.9111 7.09502 18.0198 7.49181 17.9064L12.2155 16.5554C12.7729 16.3948 13.2784 16.0972 13.6846 15.691L23.0045 6.37583C24.3318 5.04847 24.3318 2.89445 23.0045 1.56709L22.4329 0.995522C21.1055 -0.331841 18.9515 -0.331841 17.6242 0.995522ZM4.15687 2.83777C1.86114 2.83777 0 4.69891 0 6.99464V19.8431C0 22.1389 1.86114 24 4.15687 24H17.0054C19.3011 24 21.1622 22.1389 21.1622 19.8431V14.5526C21.1622 13.9243 20.6568 13.4189 20.0285 13.4189C19.4003 13.4189 18.8948 13.9243 18.8948 14.5526V19.8431C18.8948 20.8871 18.0493 21.7326 17.0054 21.7326H4.15687C3.11293 21.7326 2.26738 20.8871 2.26738 19.8431V6.99464C2.26738 5.9507 3.11293 5.10515 4.15687 5.10515H9.44742C10.0757 5.10515 10.5811 4.59971 10.5811 3.97146C10.5811 3.34321 10.0757 2.83777 9.44742 2.83777H4.15687Z"
            fill="currentColor"
         />
      </svg>
   )
}

export default EditIcon
